export default "__VITE_ASSET__Bg1uhMH0__"